var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('listagem',{ref:"listagem",attrs:{"tela":_vm.permission,"headers":_vm.headers,"data":_vm.agendamentos,"dataTotal":_vm.dataTotal,"pageSize":_vm.page_size},on:{"handleGet":_vm.handleGet}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }